export const CLOUD_ID = 'cloudId';
export const LOGIN_ID = 'loginId';
export const ORIGIN = 'origin';
export const SELECT = 'select';
export const LOGIN_METHOD = 'loginMethod';
export const CLOSE = 'close';
export const ERROR = 'error';
export const ERROR_DESCRIPTION = 'error_description';
